import styled from 'styled-components';

export const Container = styled.div`
  background: var(--white);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--gray_light);
  border-radius: 0.2rem;
  max-width: 15rem;
  color: var(--primary_color);

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.6rem;
    height: 100%;
    border: 0;
    background: transparent;
    font-size: 1.4rem;
    padding: 0 0.5rem;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  .input-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 1.6rem;
    max-width: 4.2rem;
  }

  input {
    height: 100%;
  }

  input,
  .fake-value {
    width: 100%;
    min-width: 0.8rem;
    max-width: 4.2rem;
    text-align: center;
    border: 0;
    font-size: 1rem;
    font-weight: 700;
    color: var(--primary_color);

    &:read-only {
      cursor: default;
    }
  }

  .fake-value {
    position: absolute;
    left: -0.1rem;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.3;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }

  .icon-shopping-input {
    display: flex;
    align-items: center;
    min-height: 1.38rem;
  }

  @media (max-width: 450px) {
    button {
      font-size: 1rem;
      width: 2rem;
    }

    input {
      max-width: 2rem;
    }
  }
`;
